import React from 'react';
import {Redirect} from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from '../../ApiFetcher';

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    generalButton: {
        margin: theme.spacing.unit,
    },
    textField: {
        margin: theme.spacing.unit,
    },
    form: {
        margin: 'auto',
        marginTop: theme.spacing.unit*2,
        marginBottom: theme.spacing.unit*2,
        width: '80%',
    },
    errorMessage: {
        color: 'red'
    }
});

export class LoginForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            mailAddress: '',
            password: '',
            error: []
        };

        this.onChangeMailAddress = this.onChangeMailAddress.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onClickLogin = this.onClickLogin.bind(this);
        this.handleResponseLogin = this.handleResponseLogin.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('ログイン画面');
        }
    }

    onChangeMailAddress(event){
        this.setState({mailAddress: event.target.value});
    }

    onChangePassword(event){
        this.setState({password: event.target.value});
    }

    onClickLogin(event){
        ApiFetcher.postAccountsAuthentication(this.state.mailAddress, this.state.password, this.handleResponseLogin);
        event.preventDefault();
    }

    handleResponseLogin(responseJson) {
        if (responseJson.message === null || responseJson.message === "") {
            if (responseJson.isNeedMfaSecretRegister) {
                this.props.history.replace({
                    pathname: "/mfa/register",
                    state: {
                        secret: responseJson.secret,
                        mailAddress: this.state.mailAddress,
                        password: this.state.password
                    }
                });
            } else {
                this.props.history.replace({
                    pathname: "/mfa",
                    state: {
                        mailAddress: this.state.mailAddress,
                        password: this.state.password
                    }
                });
            }
        } else {
            let isSkipMfa = false;
            if (Array.isArray(responseJson.message)) {
                for (let i = 0; i < responseJson.message.length; i++) {
                    if ('errorMessage' in responseJson.message[i] && responseJson.message[i].errorMessage === 'SKIP_MFA') {
                        isSkipMfa = true;
                        break;
                    }
                }
            }
            if (isSkipMfa) {
                // MFAをスキップする場合
                // cookieをセット
                this.props.cookies.set('id', responseJson.mfaSkipResult.id, { path: '/', secure: true });
                this.props.cookies.set('role', responseJson.mfaSkipResult.role, { path: '/', secure: true });
                this.props.cookies.set('token', responseJson.mfaSkipResult.token, { path: '/', secure: true });
                // ページ遷移.
                this.props.history.replace(this.getRedirectTo().pathname);
            } else {
                this.setState({ error: responseJson.message });
            }
        }
    }

    isLogin(){
        let id = this.props.cookies.get('id');
        let role = this.props.cookies.get('role');
        let token = this.props.cookies.get('token');
        if(id === undefined || role === undefined || token === undefined){
            return false;
        }
        return true;
    }

    getRedirectTo(){
        // リダイレクト先の指定があれば指定先へリダイレクト.なければトップ画面へリダイレクト.
        let to = this.props.location.state;
        if(to === undefined){
            to = {pathname: '/'};
        }
        return to;
    }

    static convertErrorMessagePropertyName(propertyName){
        if(propertyName === 'mailAddress'){
            return 'メールアドレス:';
        }
        else if(propertyName === 'password'){
            return 'パスワード:';
        }
        else{
            return '';
        }
    }

    render(){
        // ログイン済みの場合はリダイレクト.
        if(this.isLogin()){
            return <Redirect to={this.getRedirectTo()}/>;
        }

        return (
            <div className={this.props.classes.root}>
                <div className={this.props.classes.form}>
                    <div id="errors">
                        {this.state.error.map((row, i) =>{
                            return (
                                <div key={i} className={this.props.classes.errorMessage}>
                                    {LoginForm.convertErrorMessagePropertyName(row.propertyName)}{row.errorMessage}
                                </div>
                            )
                        })}
                    </div>
                    <div className={this.props.classes.textField}>
                        <TextField
                            id="mailAddress"
                            label="メールアドレス"
                            type="text"
                            value={this.state.value}
                            onChange={this.onChangeMailAddress}
                            variant="outlined"
                            fullWidth
                        />
                    </div>
                    <div className={this.props.classes.textField}>
                        <TextField
                            id="password"
                            label="パスワード"
                            type="password"
                            value={this.state.password}
                            onChange={this.onChangePassword}
                            variant="outlined"
                            fullWidth
                        />
                    </div>
                    <div className={this.props.classes.generalButton}>
                        <Button id="login" onClick={this.onClickLogin} variant="contained" color="primary" fullWidth>ログイン</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(LoginForm);
